<h2 mat-dialog-title class="credilow-cartel-cliente">DNI: {{ data.dni }} - {{ data.nombre || '(sin nombre)' }}</h2>
<div mat-dialog-content style="text-align: center">
	<p>Detectamos que no podemos verificar sus ingresos. Puede continuar presentando servicios.</p>
	<!-- El id lo referencia ariaDescribedBy al abrir el diálogo: mat-dialog-title sólo aporta el
	     NOMBRE accesible (la identidad del cliente), así que sin esto el lector de pantalla nunca
	     llega a decir qué se está preguntando. #9219 -->
	<p id="cartel-serv-pregunta">¿Cuántos servicios presenta?</p>
	<div class="credilow-number-of-services" role="radiogroup" aria-label="Cantidad de servicios que presenta">
		<div
			class="credilow-number-of-services-option credilow-number-of-services-option-left"
			[ngClass]="{'credilow-number-of-services-active': cantServicios === 0, sanii: !useCredilowStyle}"
			(click)="seleccionarCantServicios(0)"
			(keydown.enter)="seleccionarCantServicios(0)"
			(keydown.space)="$event.preventDefault(); seleccionarCantServicios(0)"
			id="cartel-serv-0"
			tabindex="0"
			role="radio"
			[attr.aria-checked]="cantServicios === 0"
		>
			0
		</div>
		<div
			class="credilow-number-of-services-option"
			[ngClass]="{'credilow-number-of-services-active': cantServicios === 1, sanii: !useCredilowStyle}"
			(click)="seleccionarCantServicios(1)"
			(keydown.enter)="seleccionarCantServicios(1)"
			(keydown.space)="$event.preventDefault(); seleccionarCantServicios(1)"
			id="cartel-serv-1"
			tabindex="0"
			role="radio"
			[attr.aria-checked]="cantServicios === 1"
		>
			1
		</div>
		<div
			class="credilow-number-of-services-option credilow-number-of-services-option-right"
			[ngClass]="{'credilow-number-of-services-active': cantServicios === 2, sanii: !useCredilowStyle}"
			(click)="seleccionarCantServicios(2)"
			(keydown.enter)="seleccionarCantServicios(2)"
			(keydown.space)="$event.preventDefault(); seleccionarCantServicios(2)"
			id="cartel-serv-2"
			tabindex="0"
			role="radio"
			[attr.aria-checked]="cantServicios === 2"
		>
			2
		</div>
	</div>
</div>
<div mat-dialog-actions class="justify-content-center">
	<button mat-button (click)="onCancelClick()">Cancelar solicitud</button>
	<button mat-raised-button class="continue" [ngClass]="{sanii: !useCredilowStyle}" [disabled]="cantServicios === undefined" id="cartel-continuar" (click)="onContinueClick()">Continuar</button>
</div>
